var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalCountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.804,
    height: 36.722,
    viewBox: "0 0 36.804 36.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19829",
    "data-name": "Rectangle 19829",
    width: 7.784,
    height: 5.717,
    fill: "#063255"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M52.441,119.659c-1.51-1.513-1.554-3.076-.175-4.2a3.765,3.765,0,0,1,4.535-.048c1.43,1.105,1.411,2.627-.1,4.252.293,0,.545,0,.8,0a2.726,2.726,0,0,1,2.933,2.462c.018,2.252.008,4.5,0,6.757,0,.5-.276.728-.881.728q-5,0-10,0c-.6,0-.867-.23-.867-.739,0-2.24-.011-4.479,0-6.718a2.728,2.728,0,0,1,2.948-2.489c.243,0,.486,0,.8,0m6.53,8.688c0-2.1.009-4.163-.005-6.221a1.361,1.361,0,0,0-1.522-1.222c-1.882-.006-3.764,0-5.646,0-1.062,0-1.64.493-1.641,1.4q0,2.836,0,5.672c0,.124.013.248.02.375ZM56.4,117.491a1.86,1.86,0,1,0-1.845,1.543,1.714,1.714,0,0,0,1.845-1.543",
    transform: "translate(-42.829 -103)",
    fill: "#063255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M19.3,31.248h-.47q-7.325,0-14.651,0A4.032,4.032,0,0,1,.054,27.963,4.625,4.625,0,0,1,0,27.125Q0,16.758,0,6.391a4.013,4.013,0,0,1,4.338-4.13c1.03,0,2.061,0,3.144,0,0-.464,0-.894,0-1.323,0-.593.3-.932.808-.936s.82.338.824.922c0,.431,0,.861,0,1.314H20.3c0-.439,0-.88,0-1.322A.808.808,0,0,1,21.139,0c.494.007.794.34.8.905.007.432,0,.863,0,1.354.188,0,.342,0,.5,0,1.153.017,2.313-.04,3.456.069A3.846,3.846,0,0,1,29.4,5.944c.047,1.644.02,3.29.021,4.934q0,4.151,0,8.3v.481a9.071,9.071,0,0,1,6.085,4.049,7.761,7.761,0,0,1,1.26,5.01,8.685,8.685,0,0,1-7.35,7.849A9.149,9.149,0,0,1,19.3,31.248m8.462-11.732V9.638H1.639v.436q0,8.51,0,17.019a2.45,2.45,0,0,0,2.724,2.6q7.022,0,14.044,0c.141,0,.281-.011.427-.017-.962-5.358,3.354-10.1,8.926-10.158m7.4,8.611a7.241,7.241,0,0,0-7.4-7.043,7.225,7.225,0,0,0-7.4,6.993,7.2,7.2,0,0,0,7.343,7.075,7.239,7.239,0,0,0,7.45-7.026M27.785,8.044c0-.714.032-1.391-.007-2.064a2.366,2.366,0,0,0-2.284-2.134c-.536-.024-1.073-.01-1.609-.012-.627,0-1.253,0-1.926,0,0,.487.008.93,0,1.372a.826.826,0,1,1-1.647-.01c-.005-.442,0-.884,0-1.327H9.156a.588.588,0,0,0-.028.107c0,.408,0,.816-.007,1.224a.818.818,0,1,1-1.63,0c0-.442,0-.885,0-1.36-1.211,0-2.375-.021-3.538.006A2.279,2.279,0,0,0,1.741,5.6,20.224,20.224,0,0,0,1.6,8.044Z",
    transform: "translate(0 -0.001)",
    fill: "#063255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_106120",
    "data-name": "Group 106120",
    transform: "translate(24.164 25.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106119",
    "data-name": "Group 106119",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23150",
    "data-name": "Path 23150",
    d: "M0,3.177a1.168,1.168,0,0,1,.152-.219.368.368,0,0,1,.469-.009.927.927,0,0,1,.09.081L2.388,4.708c.021.021.039.047.074.089a.8.8,0,0,1,.067-.091L7.081.152A.408.408,0,0,1,7.5.014a.386.386,0,0,1,.2.614.937.937,0,0,1-.072.079L2.774,5.561a.4.4,0,0,1-.506.1A.58.58,0,0,1,2.15,5.57q-1-1-2-2.007A1.241,1.241,0,0,1,0,3.329V3.177",
    transform: "translate(0 0)",
    fill: "#063255"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCountIcon);
export default __webpack_public_path__ + "static/media/total-count-icon.156bd4f991139bf88353c83d7c267c25.svg";
export { ForwardRef as ReactComponent };